export const PRODUCT_CREATE_NEW_SUCCESS = 'importist/product/PRODUCT_CREATE_NEW_SUCCESS';
